import { getStatusColor, getStatusForeColor, startCase } from '@/utils';
import { PriorityHigh as PriorityHighIcon } from '@mui/icons-material';
import {
  Avatar,
  Box,
  Chip,
  ListItemButton,
  ListItemText,
  Tooltip,
} from '@mui/material';
import { format } from 'date-fns';

export function IncidentListItem({ item, feature, ...props }) {
  const date = feature.properties.date
    ? format(new Date(feature.properties.date), 'dd/MM/yyyy')
    : '';

  return (
    <ListItemButton
      {...props}
      dense
      disableGutters
      sx={
        item
          ? {
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: `${item.size}px`,
              transform: `translateY(${item.start}px)`,
              px: 1,
            }
          : { px: 1 }
      }
    >
      <Box sx={{ pr: 1 }}>
        <Tooltip
          title={startCase(feature.properties?.status)}
          placement="left-end"
        >
          <Avatar
            sx={{
              color: getStatusForeColor(feature.properties?.status),
              bgcolor: getStatusColor(feature.properties?.status),
              borderColor: getStatusForeColor(feature.properties?.status),
              borderWidth: 2,
              borderStyle: 'solid',
            }}
          >
            {feature.properties?.grade || <PriorityHighIcon />}
          </Avatar>
        </Tooltip>
      </Box>
      <ListItemText
        primary={feature.properties.reference ?? ''}
        secondary={date}
        slotProps={{
          root: { sx: { flexShrink: 0 } },
          primary: { noWrap: true },
          secondary: { noWrap: true },
        }}
      />
      {feature.properties?.type?.code && (
        <Chip
          size="small"
          label={feature.properties?.type?.code}
          sx={{ fontSize: '.6rem', height: 18 }}
        />
      )}
    </ListItemButton>
  );
}
